let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("4vLaG"), load("jZrXm"), load("h4vrB")]).then(() => parcelRequire('h5BP4'));